import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Ul = styled.ul`
  padding-left: 1.5rem;
`;

interface OwnProps {
  subMenus: [{ title: string; url: string }];
}
interface OwnState {}

class MobileSubMenu extends Component<OwnProps, OwnState> {
  render() {
    return (
      <Ul className="subMenus">
        {this.props.subMenus.map((item, index) => (
          <li key={index}>
            <Link to={item.url}>
              <div>{item.title}</div>
            </Link>
          </li>
        ))}
      </Ul>
    );
  }
}
export default MobileSubMenu;
